import React from "react";
import {
  FaHashtag,
  FaHome,
  FaUserFriends,
  FaThLarge,
  FaListUl,
  FaVideo,
  FaCloudUploadAlt,
  FaStar,
  FaFileAlt,
  FaArrowUp,
  FaSignOutAlt,
  FaMusic,
  FaSort,
} from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";

const ICONS = {
  "Ordina Home": FaSort,
  "Variabile": FaHashtag,
  "Utenti": FaUserFriends,
  "Categories": FaThLarge,
  "Categoria PlayList": FaListUl,
  "Video": FaVideo,
  "Upload a Video": FaCloudUploadAlt,
  "Playlist": FaMusic,
  "Recommended": FaStar,
  "Top5": FaArrowUp,
  "Channel List": FaFileAlt,
  "Area Utente": FaHome,
};

const MENU = [
  // { link: "/admin/welcome", title: "Welcome" },
  { link: "/", title: "Area Utente" },
  { link: "/admin/homeorder", title: "Ordina Home" },
  { link: "/admin/variable", title: "Variabile" },
  { link: "/admin/utenti", title: "Utenti" },
  { link: "/admin/categories", title: "Categories" },
  { link: "/admin/playlistcategories", title: "Categoria PlayList" },
  { link: "/admin/videos", title: "Video" },
  // { link: "/admin/uploadVideo", title: "Upload a Video" },
  { link: "/admin/playlist", title: "Playlist" },
  { link: "/admin/recommended", title: "Recommended" },
  { link: "/admin/top5", title: "Top5" },
  { link: "/admin/channel", title: "Channel List" },
];

const Sidebar = () => {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

    return (
    <div className="bg-gray-300 h-screen w-56 flex flex-col justify-between items-stretch py-6">
      {/* Titolo/Logo in alto */}
      <div className="px-4 mb-6">
        <h1 className="text-xl font-bold text-gray-800 tracking-wide">
          MyTV Admin
        </h1>
      </div>

      {/* Menu */}
      <div className="space-y-1 px-2 flex-1 overflow-y-auto">
        {MENU.map((item) => {
          const Icon = ICONS[item.title];

          return (
            <NavLink
              key={item.title}
              to={item.link}
              title={item.title}
              className={({ isActive }) =>
                `flex items-center w-full px-3 py-2 rounded-md transition
                 ${isActive ? "bg-white text-gray-900 shadow" : "text-gray-700 hover:bg-gray-200"}`
              }
            >
              {({ isActive }) => (
                <>
                  <span className="flex justify-center items-center w-8 min-w-8 shrink-0">
                    {Icon ? (
                      <Icon
                        size={18}
                        className={`block shrink-0 ${
                          isActive ? "text-gray-900" : "text-gray-700"
                        }`}
                        aria-hidden="true"
                      />
                    ) : null}
                  </span>
                  <span className="ml-3 text-sm font-medium whitespace-nowrap">
                    {item.title}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>


      <button
        onClick={logout}
        title="Logout"
        className="text-red-600 hover:text-red-700 flex items-center w-full px-5 py-2 transition"
      >
        <span className="flex justify-center items-center w-8 min-w-8 shrink-0">
          <FaSignOutAlt size={20} className="block shrink-0 text-red-600" aria-hidden="true" />
        </span>
        <span className="ml-3 text-sm font-medium whitespace-nowrap">Logout</span>
      </button>
    </div>
  );
};

export default Sidebar;
